import loginReducer from '../../features/auth/utils/loginSlice';
import orderReducer from '../../features/orders/orderSlice';
import toastReducer from '../../features/toasts/toastSlice';
import ratingReducer from '../../features/rating/RatingSlice';
import notificationQRReducer from '../../features/common/components/QRNotification/notificationQRSlice';
import pushNotificationReducer from '../../features/pushNotifications/pushNotificationsSlice';
import routesReducer from '../../features/routes/routeSlice';
import { combineReducers } from 'redux';

const combinedReducers = combineReducers({
  auth: loginReducer,
  orders: orderReducer,
  toast: toastReducer,
  rating: ratingReducer,
  notificationQR: notificationQRReducer,
  pushNotification: pushNotificationReducer,
  routes: routesReducer,
});

const rootReducer = (state, action) => {
  if (action.type === 'auth/logout') {
    state = undefined;
  }

  return combinedReducers(state, action);
};

export default rootReducer;
